import React, { useEffect, useState, useContext } from "react";
import { Box } from "@mui/material";
import {
  AddContactIcon,
  UdhaarCheckoutIcon,
} from "../../../../assets/icons/icon";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import { getCustomersByBusiness } from "../../../../database/helpers/customer";
import { phoneNumRegex } from "../../../../validations";
import { getInitials, getChargeButtonTitle } from "../../../../utils";
import AddCustomerModal from "../../../common/Modals/AddCustomerModal";
import styles from "./styles.module.css";

export default function UdhaarSale({
  totalAmount,
  businessId,
  confirmSale,
  customer,
  activeSaleOrder,
  isLoadingbtn = false,
  isFocussedRef,
}) {
  const [I18n] = useContext(LanguageContext);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [contactList, setContactList] = useState([]);
  const [addContact, setAddContact] = useState(false);
  const [createCustomerModal, setCreateCustomerModal] = useState(false);
  const [initName, setInitname] = useState("");
  const [initPhone, setInitphone] = useState("");

  useEffect(() => {
    if (customer) {
      setSelectedCustomer(customer);
    }
  }, [customer]);

  useEffect(() => {
    const businessId = activeSaleOrder?._raw?.business_id;
    if (!businessId) return;
    getCustomersByBusiness(businessId).then((customers) => {
      setContactList(
        customers.map((c) => ({
          id: c.id,
          label: c._raw?.name || "",
          value: c._raw?.name || "",
        })),
      );
    });
  }, [activeSaleOrder?._raw?.business_id]);

  const openCreateCustomerModal = (value) => {
    if (value?.match?.(phoneNumRegex) === null) {
      setInitname(value);
      setInitphone("");
    } else {
      setInitphone(value);
      setInitname("");
    }
    setCreateCustomerModal(true);
  };

  const attachCustomer = async (customer) => {
    try {
      setSelectedCustomer(customer ?? null);
      await activeSaleOrder.updateSaleOrderCustomer(customer);
      if (customer?.id)
        triggerLogEvent(analytics, "pos_payment_udhaar_customer");
    } catch (error) {
    }
  };

  const handleAddCustomer = (payload) => {
    setCreateCustomerModal(false);
    attachCustomer(payload ?? null);
    if (payload?.id) triggerLogEvent(analytics, "pos_customer_added_with_sale");
  };

  return (
    <Box
      flex={1}
      className="h-100 w-100"
      display={"flex"}
      flexDirection={"column"}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width={"100%"}
        flex={11}
        className="udhaarIconWrapper"
      >
        <Box mb={"0.63rem"}>
          <ParagraphText
            className={`fontWeight400 fontSize14 newFontColor ${styles.billAmount}`}
          >
            {I18n.bill_amount}
          </ParagraphText>
        </Box>
        <Box mb={"1.5rem"}>
          <ParagraphText
            className={`fontWeight600 newFontColor fontSize32`}
            style={{ lineHeight: "40px" }}
          >
            Rs. {formatNum(totalAmount)}
          </ParagraphText>
        </Box>

        <Box mb={"0.63rem"}>
          <ParagraphText
            style={{ lineHeight: "22px" }}
            className={`fontWeight500 fontSize16 newLightColor ${styles.billAmount}`}
          >
            {I18n.udhaar_checkout}
          </ParagraphText>
        </Box>

      <Box className={styles.udhaarDropdownContainer} >
        <TabAutoComplete
          id="quick_contactlist"
          list={contactList}
          className={styles.customerSearch}
          hideSuffixIcon
          prefixIcon={
            <Box className={styles.prefixContainer}>
              {selectedCustomer?.name ? (
                <ParagraphText className={styles.contactName}>
                  {getInitials(selectedCustomer.name)}
                </ParagraphText>
              ) : (
                <AddContactIcon width={12} height={12} />
              )}
            </Box>
          }
          handleSelect={(item) => {
            const customer = item ? { id: item.id, name: item.label } : null;
            attachCustomer(customer);
            if (item?.id)
              triggerLogEvent(analytics, "pos_customer_added_with_sale");
          }}
          value={selectedCustomer?.name || ""}
          handleCreate={openCreateCustomerModal}
          asCreate = {"contact"}
          placeholder={I18n.add_contact}
          handleStartLogEvent={() =>
            triggerLogEvent(analytics, "pos_customer_start")
          }
          manuallyFocusInput={addContact}
          handleManuallyInput={() => setAddContact(false)}
          onFocus={() => (isFocussedRef.current = true)}
          onBlur={() => (isFocussedRef.current = false)}
        />
</Box>

      </Box>
      <Box flex={1}>
        <UBButton
          id="udhaar_checkout_proceed_btn"
          title={getChargeButtonTitle(I18n, totalAmount)}
          className={`charges-amount-btn ubPrimaryButton ${!!selectedCustomer ? "active" : ""}`}
          disabled={isLoadingbtn || !selectedCustomer}
          onClick={() => confirmSale(null, selectedCustomer)}
          style={{
            border: selectedCustomer ? "" : "1px solid #D0D3D9",
          }}
        />
      </Box>

      <AddCustomerModal
        isOpen={createCustomerModal}
        handleClose={() => setCreateCustomerModal(false)}
        initialName={initName}
        initialPhone={initPhone}
        onSaveCallback={handleAddCustomer}
        type="in"
        isTypeField={false}
      />
    </Box>
  );
}
